export type SystemVertical = {
  readonly code: string;
  readonly isSystem: boolean;
  readonly name: string;
  readonly status: "active" | "disabled";
};

export type SystemCategory = {
  readonly isSystem: boolean;
  readonly name: string;
};

export const SYSTEM_VERTICALS: readonly SystemVertical[] = [
  { code: "TELCO", isSystem: false, name: "Telco", status: "active" },
  { code: "GENERAL", isSystem: true, name: "General", status: "active" },
  { code: "POWER", isSystem: false, name: "Power", status: "active" },
  { code: "ENERGY", isSystem: false, name: "Energy", status: "active" },
  { code: "WATER", isSystem: false, name: "Water", status: "active" },
  { code: "OTHER", isSystem: false, name: "Other", status: "active" },
];

export const SYSTEM_CATEGORIES: readonly SystemCategory[] = [
  { isSystem: false, name: "Installation" },
  { isSystem: false, name: "Maintenance" },
  { isSystem: false, name: "Safety" },
  { isSystem: false, name: "RAN" },
  { isSystem: false, name: "RF" },
  { isSystem: false, name: "Power" },
];
